import memoize from 'lodash/memoize'
import debounce from 'lodash/debounce'

type MemoizedDebounceFuncType = (param: any, count: number) => void
interface MemoizedDebounceFuncOptions {
  resolver?: (...args: any[]) => any
  leading?: boolean
  maxWait?: number
  trailing?: boolean
}
interface ToBeDebouncedFuncExtra {
  count?: number
}
type ToBeDebouncedFunc = ToBeDebouncedFuncExtra & (() => void)

export function memoizedDebounce(
  func: MemoizedDebounceFuncType,
  wait = 0,
  options: MemoizedDebounceFuncOptions = {}
) {
  const mem = memoize(function () {
    const finalFunc: ToBeDebouncedFunc = function (this: any) {
      // TODO: this error popped up when moving the checkout-instore project
      // to checkout-instore-legacy, but needs to be fixed at some point
      // @ts-ignore
      func.apply(this, arguments)
      mem.cache.delete(arguments[0])
    }
    const debounced = debounce(finalFunc, wait, options)
    // TODO: this error popped up when moving the checkout-instore project
    // to checkout-instore-legacy, but needs to be fixed at some point
    // @ts-ignore
    debounced.count = 0
    return debounced
  }, options.resolver)

  return function (this: any, ...args: any[]) {
    // TODO: this error popped up when moving the checkout-instore project
    // to checkout-instore-legacy, but needs to be fixed at some point
    // @ts-ignore
    const memo = mem.apply(this, args)
    // TODO: this error popped up when moving the checkout-instore project
    // to checkout-instore-legacy, but needs to be fixed at some point
    // @ts-ignore
    memo.count++
    // TODO: this error popped up when moving the checkout-instore project
    // to checkout-instore-legacy, but needs to be fixed at some point
    // @ts-ignore
    // TODO: this error popped up when moving the checkout-instore project
    // to checkout-instore-legacy, but needs to be fixed at some point
    // @ts-ignore
    memo.apply(this, args.concat([memo.count]))
  }
}
